import type { AxiosRequestConfig } from "axios";
import api from "../utils/api";

export interface QueryFetchContext {
  signal?: AbortSignal;
}

export async function getJson<T>(
  url: string,
  params?: Record<string, unknown>,
  ctx?: QueryFetchContext,
  config?: AxiosRequestConfig,
): Promise<T> {
  const { data } = await api.get<T>(url, {
    ...config,
    params: { ...config?.params, ...params },
    signal: ctx?.signal,
  });
  return data;
}

// fetch con la sesión de utils/api (Authorization con renovación, x-session-id)
// para quien leía la respuesta como Response: /mapon y /wialon dejaron de ser
// anónimos (#688) y sus pantallas leen el cuerpo también en errores (Wialon
// manda su código ahí), así que no se lanza por status. Sin x-company-id: son
// vistas de reseller sobre todas las compañías.
export async function apiFetch(
  url: string,
  init: { headers?: Record<string, string>; signal?: AbortSignal } = {},
): Promise<{ ok: boolean; status: number; statusText: string; json: () => Promise<any> }> {
  const res = await api.get(url, {
    headers: init.headers,
    signal: init.signal,
    validateStatus: () => true,
    _skipCompanyScope: true,
  } as AxiosRequestConfig);
  return { ok: res.status >= 200 && res.status < 300, status: res.status, statusText: res.statusText, json: async () => res.data };
}
